
import template from './view-entry.html'
import FileStoreHTTP from '../lib/FileStoreHTTP.mjs';
import ResourceVM from '../lib/ResourceVM.mjs';

class ViewEntryViewModel
{
	constructor(dialog, entry)
	{
		this.dialog = dialog;
		this.entry = entry; //Resource entry
		
		this.FS = new FileStoreHTTP();

		this.selected_tab = ko.observable('general');

		this.status_code = ko.observable();

		this.status_title = ko.observable();
		this.status_message = ko.observable();

		this.title = ko.observable('Resource: ' + entry.href());
		this.resource = ko.observable(null);
		this.properties = ko.observableArray([]);
		this.acl = ko.observableArray([]);
		this.locks = ko.observableArray([]);

		this.versionedstate = ko.observable({state:'NA'});
		this.version_status = ko.observable('NA');
		
		this.history_loaded = false;
		this.history = ko.observableArray([]);
		this.selected_version_nr = ko.observable();
		this.selected_version = ko.observable();

		this.resourcetype = ko.observable();
		this.resource_id = ko.observable();
		this.contentlength = ko.observable();
		this.contenttype = ko.observable();
		
		this.icon = ko.observable();

		this.childcount = ko.observable('0');
		this.creationdate = ko.observable();
		this.lastmodified = ko.observable();
		this.img_url = ko.observable();
		this.current_user_privileges = ko.observableArray([]);
		this.owner = ko.observable(null);

		this.editing_displayname = ko.observable(false);
		this.new_displayname = ko.observable();

		this.set_owner_state = ko.observable(null);
		this.all_users = ko.observableArray();
		this.all_owner_options = ko.observableArray();
		this.selected_new_owner = ko.observable();
		this.selected_owner_option = ko.observable();

		this.exclusive_lock = ko.observable(null);

	}

	switch_tabs (data, event)
	{
		let tabs = document.querySelectorAll('#view_file_entry_dialog_nav li');

		tabs.forEach((tab) => {
			tab.classList.remove('active');
		});
		
		event.currentTarget.classList.add('active');
		
		this.selected_tab(event.currentTarget.getAttribute('data-tabname'));
	}

	/* Set resource and get initial info */
	async setResource ()
	{
		let resource = null;
		resource = new ResourceVM(this.FS, this.entry.href);

		let status_code = null;

		let add_props = [ 
			{nsuri: 'DAV:', name: 'current-user-privilege-set'},
			{nsuri: 'DAV:', name: 'resourcetype'},
			{nsuri: 'DAV:', name: 'resource-id'},
			{nsuri: 'DAV:', name: 'owner'},
			{nsuri: 'PS:', name: 'versionedstate'}
		];

		try {
			await resource.populate(add_props);

			this.current_user_privileges(resource.get('DAV:', 'current-user-privilege-set') || []);
			this.resourcetype(resource.get('DAV:', 'resourcetype'));
			this.versionedstate(resource.get('PS:', 'versionedstate'));
			let res_id = resource.get('DAV:', 'resource-id');
			if (res_id && res_id.startsWith('urn:uuid:'))
				this.resource_id(res_id.substr(9));
			else
				this.resource_id(res_id);

			this.resource(resource);

			if (this.versionedstate())
			{
				await this.fetchHistory();

				// Subscribe to version nr update
				this.selected_version_nr.subscribe((vn) => {
					let version = this.history().find((x) => x.version === vn);
					if (!version)
						return;
					if (!this.resource())
						return;
					this.resource().version_label(version.labels[0]);
					this.updateInfo();
				});

			}

			status_code = 'OK';

		} catch (err) {
			console.error(err);

			status_code = 'ERROR';
			
			if (err.code == 403)
			{
				this.status_title('Forbidden!');
				this.status_message('You do not have access permission to this resource.');
			}
			else if (err.code == 404)
			{
				this.status_title('Not found!');
				this.status_message('The resource does not exist.');
			}
			else if (err.code >= 500)
			{
				this.status_title('Server error!');
				this.status_message('A server error has occured!');
			}
			else if (err.code >= 400)
			{
				this.status_title('Bad request!');
				this.status_message('The server reported a bad request (status=' + jqXHR.status + ').');
			}
			else
			{
				console.log('OTHER:', err.message);
				this.status_message('Error: ' + err.message);
			}
		}
	
		this.status_code(status_code);
		return status_code;
	} // setResource

	
	async updateInfo ()
	{
		let resource = null;
		if (!this.resource())
		{
			resource = new ResourceVM(this.FS, this.entry.href);
		}
		else
		{
			resource = this.resource();
		}

		let add_props = [ 
			{nsuri: 'DAV:', name: 'acl'},
			{nsuri: 'DAV:', name: 'current-user-privilege-set'},
			{nsuri: 'DAV:', name: 'checked-in'},
			{nsuri: 'DAV:', name: 'checked-out'},
			{nsuri: 'DAV:', name: 'creationdate'},
			{nsuri: 'DAV:', name: 'childcount'},
			{nsuri: 'DAV:', name: 'getcontentlength'},
			{nsuri: 'DAV:', name: 'getcontenttype'},
			{nsuri: 'DAV:', name: 'getlastmodified'},
			{nsuri: 'DAV:', name: 'iscollection'},
			{nsuri: 'DAV:', name: 'lockdiscovery'},
			{nsuri: 'DAV:', name: 'resourcetype'},
			{nsuri: 'DAV:', name: 'resource-id'},
			{nsuri: 'DAV:', name: 'supported-privilege-set'},
			{nsuri: 'PS:', name: 'versionedstate'},
			{nsuri: 'DAV:', name: 'owner'},
			{nsuri: 'PS:', name: 'icon'}
		];

		try {
			await resource.populate(add_props);

			this.acl(resource.get('DAV:', 'acl'));
			this.resourcetype(resource.get('DAV:', 'resourcetype'));
			this.contenttype(resource.get('DAV:', 'getcontenttype') || 'unknown');
			this.contentlength(resource.get('DAV:', 'getcontentlength'));
			this.creationdate(resource.get('DAV:', 'creationdate'));
			this.childcount(resource.get('DAV:', 'childcount') || '0');
			this.lastmodified(resource.get('DAV:', 'getlastmodified'));
			console.log('this.lastmodified=', this.lastmodified());
			this.versionedstate(resource.get('PS:', 'versionedstate'));
			this.icon(resource.get('PS:', 'icon'));
			this.owner(resource.get('DAV:', 'owner'));
			this.current_user_privileges(resource.get('DAV:', 'current-user-privilege-set') || []);
			this.resource_id(resource.get('DAV:', 'resource-id'));

			this.properties(resource.property_list.properties);

			this.locks(resource.locks());
		
			this.resource(resource);

			this.status_code('OK');

		} catch (err) {
			console.error(err);
			this.status_code('ERROR');
		}

	} // updateInfo

	async deleteACE (ace)
	{
		let result = await Grape.alerts.confirm({type: 'warning', title: 'Delete ACE', message: 'Are you sure you want to delete this ACE record for ' + ace.principal.name + '?'});
		if (!result)
			return;

		try {
			await window.Grape.fetches.fetch(`/grape-filestore/ace/${ace.ace_uuid}`, {
				method: 'DELETE',
			});
		} catch (err) {
			console.log(err);
			let message = 'Error while deleting ACE';
			if (err.jqXHR)
				message += ' (status=' + err.jqXHR.textStatus + ')';
			else if (err.message)
				message += ' (' + err.message + ')';
			Grape.alerts.alert({
				type: 'danger',
				title: 'Error',
				message: message
			});
			return;
		}
		this.updateInfo();
	}

	async fetchHistory()
	{
		if (this.resource().collection() === true)
		{
			this.history([]);
			this.version_status(null);
			return;
		}
		
		let versions = await this.resource().report('DAV:', 'version-tree', {
			get: [
				'{DAV:}creator-displayname',
				'{DAV:}getcontentlength',
				'{DAV:}getlastmodified',
				'{DAV:}comment'
			]});

		this.version_status('CI');
		for (let version of versions)
		{
			version.contentlength = 0;
			version.label = version.labels.join(', ');
			version.comment = '';
			for (let prop of version.properties.values || [])
			{
				if (prop.nsuri == 'DAV:' && prop.name == 'creator-displayname')
					version.creator = prop.value;
				else if (prop.nsuri == 'DAV:' && prop.name == 'getcontentlength')
					version.contentlength = prop.value;
				else if (prop.nsuri == 'DAV:' && prop.name == 'getlastmodified')
					version.lastmodified = prop.value;
				else if (prop.nsuri == 'DAV:' && prop.name == 'comment')
					version.comment = prop.value;
			}
		}

		let set_new_version = null;
		if (typeof this.selected_version_nr() == 'undefined')
			set_new_version = versions[versions.length-1].version;
		this.history(versions);
		if (set_new_version !== null)
			this.selected_version_nr(set_new_version);
	}

	async btnVersionControl_click()
	{
		await Grape.fetches.postJSON('/grape-filestore/version-control', {path: this.entry.href()});
		this.updateInfo();
	}
	
	async btnCheckout_click()
	{
		await this.resource().checkout();
		await this.resource().populate([{nsuri: 'PS:', name: 'versionedstate'}]);
		this.versionedstate(this.resource().get('PS:', 'versionedstate'));
		await this.fetchHistory();
	}
	
	async btnCheckin_click()
	{
		await this.resource().checkin();
		await this.resource().populate([{nsuri: 'PS:', name: 'versionedstate'}]);
		this.versionedstate(this.resource().get('PS:', 'versionedstate'));
		await this.fetchHistory();
	}

	async btnDeleteLock_click(lockinfo)
	{
		if (!(lockinfo?.locktoken))
		{
			console.warn('Invalid locktoken value for unlock');
			return;
		}

		let result = await Grape.alerts.confirm({type: 'warning', title: 'Delete lock', message: 'Are you sure you want to delete this lock?'});
		if (!result)
			return;

		await this.resource().unlock(lockinfo.locktoken);
		this.updateInfo();
	}

	btnClose_click()
	{
		this.dialog.close();
	}


	async editACE_click (ace)
	{
		let res_id = this.resource().get('DAV:', 'resource-id');
		if (res_id.startsWith('urn:uuid:'))
			res_id = res_id.substr(9);

		let result = await Grape.dialog.open('EditACE', {resource: {id: res_id}, ace: ace});
		if (result)
			this.updateInfo();
	}

	async addACE_click ()
	{
		let res_id = this.resource().get('DAV:', 'resource-id');
		if (res_id.startsWith('urn:uuid:'))
			res_id = res_id.substr(9);

		let r = await Grape.dialog.open('EditACE', {resource: {id: res_id}});
		if (r)
			this.updateInfo();
	}


	async setIcon_click ()
	{
		let result = await Grape.dialog.open('FileSelector', {
			title: 'Choose icon...',
			location: '/DAV/icons/' /* TODO get from settings */
			});
		console.log('dialog result=', result);
		if (result)
		{
			try {
				const save_result = await this.resource().save_property('PS:', 'icon', result);
				console.log('save-result:',save_result);
			} catch (err) {
				if (err.status == '423')
				{
					Grape.alerts.alert({type: 'error', title: 'Locked', message: 'Unable to save icon because the resource is locked'});
				}
				else
				{
					Grape.alerts.alert({type: 'error', title: err.status || 'Error', message: err.message});
				}
			}
			this.updateInfo();
		}
	}

	async setOwner_click ()
	{
		if (this.set_owner_state() == null)
		{
			let users = (await Grape.cache.fetch('Users')) || [];
			this.all_users(users);

			let options = [];
			for (let u of users)
				options.push({type: 'user', name: u.username, display: `${u.username} (User)`});

			let groups = await Grape.cache.fetch('AccessRoles') || [];
			for (let r of groups)
				options.push({type: 'role', name: r.role_name, display: `${r.role_name} (Role)`});

			this.all_owner_options(options);
			this.set_owner_state('editing');

			let current_name = this.owner() ? this.owner().name : '';
			let match = options.find((o) => o.name === current_name);
			this.selected_owner_option(match || null);
			return;
		}

		if (this.set_owner_state() == 'editing')
		{
			let selected = this.selected_owner_option();
			if (!selected)
				return;
			try {
				let prop_value;
				if (selected.type === 'role')
					prop_value = {role_name: selected.name};
				else
					prop_value = {name: selected.name};
				await this.resource().save_property('DAV:', 'owner', prop_value);
			} catch (err) {
				if (err.status == '423')
				{
					Grape.alerts.alert({type: 'error', title: 'Locked', message: 'Unable to save owner because the resource is locked'});
				}
				else
				{
					Grape.alerts.alert({type: 'error', title: err.status || 'Error', message: err.message});
				}
			}
			this.set_owner_state(null);
			this.updateInfo();
		}
	}


	async acquireExclusiveLock ()
	{
		await this.resource().lock('write', 'exclusive', 'infinite', -1);
		this.updateInfo();
	}

	async acquireSharedLock ()
	{
		await this.resource().lock('write', 'shared', 'infinite', -1);
		this.updateInfo();
	}

	async acquireCustomLock ()
	{
		let lockinfo = await Grape.dialog.open('LockInfoInput', {lock: null});
		if (lockinfo)
		{
			await this.resource().lock(lockinfo.type, lockinfo.scope, lockinfo.depth, lockinfo.lifetime);
		}
		this.updateInfo();
	}

	editDisplayname_click ()
	{
		this.new_displayname(this.displayname());
		this.editing_displayname(true);
	}

	saveDisplayname_click ()
	{
		//this.editing_displayname(false);
	}

	async fetchAllProps_click()
	{
		this.properties([]);
		await this.resource().populate([{nsuri: 'PS:', name: 'real-allprop'}]);
		this.properties(this.resource().property_list.properties);
	}

	async editResourceTypes_click()
	{
		let result = await Grape.dialog.open('EditResourceTypes', {resource: this.resource()});
		if (result)
			this.updateInfo();
	}

	async editPropertyValue_click()
	{
		let result = await Grape.dialog.open('EditPropertyValue', {resource: this.resource()});
		if (result)
			this.updateInfo();
	}

	async populatePropertyValue_click(prop)
	{
		this.properties([]);
		await this.resource().populate([{nsuri: prop.nsuri, name: prop.name}]);
		let props = [];
		for (let prop of this.resource().property_list.properties)
			props.push(prop);
		this.properties(props);
	}
}

class ViewFileEntryDialog
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ViewEntryViewModel(this, bindings.entry);
		this.name = 'ViewResourceEntryDialog';
	}

	async init ()
	{
		console.log('ViewResourceEntryDialog Dialog init');
		let status_code = await this.viewModel.setResource();
		if (status_code == 'OK')
			await this.viewModel.updateInfo();
	}
}

export default {
	name: 'ViewResourceEntryDialog',
	dialog_class: ViewFileEntryDialog,
	template: template,
	provider: 'ps'
};
